import { render, staticRenderFns } from "./weightRecordingBetweenTwoDays.vue?vue&type=template&id=b4245152&scoped=true&"
import script from "./weightRecordingBetweenTwoDays.vue?vue&type=script&lang=js&"
export * from "./weightRecordingBetweenTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4245152",
  null
  
)

export default component.exports